const safeParse = (rawValue) => {
   if (rawValue === null || rawValue === undefined) return null;
   if (rawValue === "undefined" || rawValue === "null" || rawValue === "") return null;

   try {
      return JSON.parse(rawValue);
   } catch (error) {
      return null;
   }
};

export const SessionService = {
   setItem(key, value) {
      sessionStorage.setItem(key, JSON.stringify(value));
   },

   getItem(key) {
      return safeParse(sessionStorage.getItem(key));
   },

   clear() {
      sessionStorage.clear();
   },

   removeItem(key) {
      sessionStorage.removeItem(key);
   }
};
